(function () {
  try {

    const JARS_PER_TIER = {
      0: 1,
      1: 4,
      2: 6
    };
    const SERVINGS_PER_JAR = 6;

    function formatServing(priceCents, servings) {
      var perServing = (priceCents / 100) / servings;
      return '$' + perServing.toFixed(2) + '/serving';
    }

    function updateAllBadges() {
      try {
        var rows = document.querySelectorAll('div.bndlr-radio-container[data-discount-index]');
        console.log('[Forte Per Serving] Updating badges. Found rows:', rows.length);

        rows.forEach(function (row) {
          var discountIndex = parseInt(row.getAttribute('data-discount-index'), 10);
          var jars = JARS_PER_TIER[discountIndex];
          if (!jars) return;
          var servings = jars * SERVINGS_PER_JAR;

          var priceEl = row.querySelector('span.bndlr-discounted-price');
          var badgeEl = row.querySelector('div.bndlr-savings-text');

          if (!priceEl || !badgeEl) {
            console.log('[Forte Per Serving] Missing elements for index:', discountIndex);
            return;
          }

          var priceCents = parseInt(priceEl.getAttribute('data-currentprice'), 10);
          if (isNaN(priceCents) || priceCents <= 0) return;

          var label = formatServing(priceCents, servings);
          badgeEl.textContent = label;
          console.log('[Forte Per Serving] Index', discountIndex, '→', label);
        });
      } catch (err) {
        console.log('[Forte Per Serving] updateAllBadges error:', err);
      }
    }

    document.addEventListener('bundler:bundle_widget_created', function () {
      console.log('[Forte Per Serving] bundler:bundle_widget_created fired');
      updateAllBadges();
    });

    document.addEventListener('sealsubs:subscription_widget_created', function () {
      console.log('[Forte Per Serving] sealsubs:subscription_widget_created fired');
      setTimeout(updateAllBadges, 150);
    });

    document.addEventListener('sealsubs:price_update', function (e) {
      console.log('[Forte Per Serving] sealsubs:price_update fired', e.detail);
      setTimeout(updateAllBadges, 150);
    });

    document.addEventListener('sealsubs:selling_plan_changed', function (e) {
      console.log('[Forte Per Serving] sealsubs:selling_plan_changed fired', e.detail);
      setTimeout(updateAllBadges, 150);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        setTimeout(updateAllBadges, 500);
      });
    } else {
      setTimeout(updateAllBadges, 500);
    }

  } catch (err) {
    console.log('[Forte Per Serving] Init error:', err);
  }
})();
